<template>
    <div class="min-h-screen text-center text-14 text-a-gray-a4a4a4" data-cy="section_notfound_main">
        <div class="absolute left-0 right-0 top-1/2" data-cy="text_notfound_message">{{lbl.page_not_found}}</div>
    </div>
</template>
<script>
//mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';

export default {
    name: 'Notfound',
    mixins: [LocaleMixin],
}
</script>
<style lang="scss" scoped>
</style>
